import CropSquareIcon from '@mui/icons-material/CropSquare';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import NavigationIcon from '@mui/icons-material/Navigation';
import { Button, Paper, Popper, styled } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import { HereMapColors } from '../../styles/agistics-colors';

export const HereMapKey = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    return (
        <>
            <Button
                variant='contained'
                color='inherit'
                sx={{ position: 'absolute', top: '1em', left: '1em', zIndex: 500 }}
                onClick={handleClick}
            >
                {L.mapKey()}
            </Button>
            <Popper open={Boolean(anchorEl)} anchorEl={anchorEl} placement='bottom-start' disablePortal style={{ zIndex: 1200 }}>
                <Paper style={{ padding: '0.5em' }}>
                    <KeyRow>
                        <HorizontalRuleIcon style={{ color: HereMapColors.CALCULATED_ROUTE}} />
                        {L.calculatedRoute()}
                    </KeyRow>
                    <KeyRow>
                        <HorizontalRuleIcon style={{color: HereMapColors.ACTIVE}} />
                        {L.actualRoute()}
                    </KeyRow>
                    <KeyRow>
                        <HorizontalRuleIcon style={{color: HereMapColors.STANDARD_ROUTE}} />
                        {L.standardRoute()}
                    </KeyRow>
                    <KeyRow>
                        <HorizontalRuleIcon style={{color: HereMapColors.SMART_TRAILER}} />
                        {L.smartTrailerRoute()}
                    </KeyRow>
                    <KeyRow>
                        {/** height/width/padding important here to ensure consistency with mui icon sizing */}
                        <div style={{ color: HereMapColors.ACTIVE, height: '1em', width: '1em', padding: '0.25rem' }}>- -</div>
                        {L.recalculatedDriverRoute()}
                    </KeyRow>

                    <KeyRow>
                        <NavigationIcon style={{color: HereMapColors.ACTIVE}} />
                        {L.loadedDriver()}
                    </KeyRow>
                    <KeyRow>
                        <NavigationIcon style={{color: HereMapColors.INACTIVE}} />
                        {L.nonLoadedDriver()}
                    </KeyRow>

                    <KeyRow>
                        <CropSquareIcon style={{color: HereMapColors.AVOIDANCE_ZONE}} />
                        {L.avoidanceZone()}
                    </KeyRow>
                    <KeyRow>
                        <CropSquareIcon style={{color: HereMapColors.GLOBAL_AVOIDANCE_ZONE}} />
                        {L.globalAvoidanceZone()}
                    </KeyRow>
                </Paper>
            </Popper>
        </>
    )
}

const KeyRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
});